<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')">
          <CloseSvg />
        </a>
      </div>
      <div class="title">
        נמצאו {{ docs.length }} רופאים עבור
        <br />
        {{ id }}, בחירת רופא
        <br />
        לצפייה ביומן
      </div>
      <div class="flex flex--content--center">
        <select2 v-model="selectedDoc">
          <option value="">בחר רופא</option>
          <option
            v-for="doc in docs"
            :key="doc.doctor_id"
            :value="doc.doctor_id"
            >{{ doc.heb_name }}</option
          >
        </select2>
        <a
          class="bt_blue"
          href="javascript:void(0)"
          @click.prevent="goToSearch"
        >
          הבא
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
export default {
  name: "SearchDocSelect",
  props: ["id", "docs"],
  data() {
    return {
      selectedDoc: ""
    };
  },
  mounted() {},
  methods: {
    goToSearch() {
      this.$root.$emit("selected-doctor", { doc: this.selectedDoc });
      this.$emit("close");
    }
  },
  components: {
    CloseSvg
  }
};
</script>

<style scoped>
.popup_close svg path {
  fill: #1f237b;
}
</style>
